<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <app-modal
    *ngIf="showDeleteAccountModal"
    [show]="showDeleteAccountModal"
    [showBuddy]="false"
    [cycModal]="true"
    (showChange)="showDeleteAccountModal = $event"
  >
    <app-delete-user-confirmation
      (confirm)="deleteAccount()"
    ></app-delete-user-confirmation>
  </app-modal>
  <section *ngIf="pageData">
    <div class="content-wrapper top-section">
      <h1>My profile</h1>
      <div class="seperator"></div>

      <div class="profile-summary">
        <div class="content">
          <h1>Hello,</h1>
          <h1>
            {{ auth.currentUser?.firstName }} {{ auth.currentUser?.lastName }}
          </h1>
          <div class="seperator grey"></div>
          <div class="details">
            <div class="user">
              <p class="no-margin" *ngIf="auth.currentUser?.email">
                {{ auth.currentUser?.email }}
              </p>
              <p
                class="no-margin"
                *ngIf="
                  auth.currentUser?.university &&
                  !auth.currentUser?.university?.is_unihome_product
                "
              >
                {{ auth.currentUser?.university?.name }},
              </p>
              <p
                *ngIf="
                  auth.currentUser?.university &&
                  !auth.currentUser?.university?.is_unihome_product
                "
              >
                {{ auth.currentUser?.accommodation?.name }}
              </p>
            </div>
            <button routerLink="/app/my-profile/update">Update Details</button>
          </div>
        </div>
        <div class="summary-image-wrapper">
          <img
            *ngIf="pageData.header_image?.data?.attributes?.url"
            class="summary-image"
            [src]="pageData.header_image?.data?.attributes?.url"
            alt="header_image"
          />
        </div>
      </div>
    </div>
  </section>
</div>
<div class="background">
  <section class="page-wrapper">
    <div class="content-wrapper links">
      <div class="profile-links">
        <ul>
          <li>
            <a routerLink="/app/my-profile/marketing-preferences">
              Preferences
            </a>
          </li>
          <li>
            <a routerLink="/app/my-profile/terms-and-conditions">
              Terms &amp; conditions
            </a>
          </li>
          <li>
            <a routerLink="/app/my-profile/privacy-notice"> Privacy notice </a>
          </li>
          <li>
            <a routerLink="/app/my-profile/howden-for-students">
              About Howden for Students
            </a>
          </li>
          <li>
            <a routerLink="/app/my-profile/app-terms-of-use">
              App terms of use
            </a>
          </li>
          <li>
            <a
              href="https://www.howdengroup.com/uk-en/cookies-policy"
              target="_blank"
            >
              Cookie policy
            </a>
          </li>
        </ul>
      </div>
      <div class="useful-links">
        <h2>Useful links</h2>
        <div class="seperator grey"></div>
        <ul>
          <li><a routerLink="/contact-us">Contact us</a></li>
          <li *ngIf="!auth.currentUser?.university?.is_unihome_product">
            <a routerLink="/app/my-profile/faqs">FAQs</a>
          </li>
          <li>
            <a href="https://www.howdengroup.com/uk-en/">howdengroup.com</a>
          </li>
        </ul>
        <button class="button profile-logout" (click)="auth.logout()">
          Log out
        </button>
      </div>
    </div>
    <p class="delete-account" (click)="toggleAccoutDeletionModal()">
      Delete Account
    </p>
  </section>
</div>
